import { createBrowserRouter } from "react-router-dom";
import routes from "./config/routes";


const router = createBrowserRouter(routes);


export default router;